import React from 'react';
import { Level } from '../../types/level';
import { getSize, LevelHeight, LevelWidth } from '../../types/levelUtils';
import './svg-level-render.css';

const RenderScale: number = 4;

interface Props {
  level: Level;
  active: boolean;
  enabled: boolean;
  onClick?: () => void;
}

const SVGLevelRenderComponent = ({ level, active, enabled, onClick }: Props) => {
  const handleClick = () => {
    onClick && onClick();
  };

  const width = LevelWidth(level) * RenderScale;
  const height = LevelHeight(level) * RenderScale;

  return (
    <button
      type="button"
      disabled={!enabled}
      className={`svg-render ${active ? 'svg-render-active' : ''}`}
      onClick={handleClick}
    >
      <svg version="1.1" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
        {level.words.map((w, ind) => {
          const size = getSize(w);
          const width = w.metadata.isVertical ? RenderScale : size * RenderScale;
          const height = w.metadata.isVertical ? size * RenderScale : RenderScale;

          return (
            <rect
              key={ind}
              x={w.metadata.x * RenderScale}
              y={w.metadata.y * RenderScale}
              width={width}
              height={height}
              stroke="none"
              fill="black"
            />
          );
        })}
      </svg>
    </button>
  );
};

export default SVGLevelRenderComponent;
